module.exports = __webpack_public_path__ + "static/media/chevron.df8f4c5a.svg";